import {
    CustomItemFormStructure,
    CustomItemRenderFieldProps,
    ExtandedFormContext,
} from '@europrocurement/flexy-form';
import { Box, Typography } from '@mui/material';
import React from 'react';

import { PercentWidget } from '@europrocurement/flexy-components';

// eslint-disable-next-line import/no-cycle
import DirigeantPPView from './DirigeantPPView/DirigeantPPView';
// eslint-disable-next-line import/no-cycle
import BeneficiaireView from './BeneficiaireView/BeneficiaireView';
// eslint-disable-next-line import/no-cycle
import DirigeantPMView from './DirigeantPMView/DirigeantPMView';
// eslint-disable-next-line import/no-cycle
import { EntreprisesIntervenantView } from './EntreprisesIntervenantView/EntreprisesIntervenantView';
// eslint-disable-next-line import/no-cycle
import { NomsDeDomaineView } from './NomsDeDomaine/NomsDeDomaineView';
// eslint-disable-next-line import/no-cycle
import { ActiviteView } from './Activite/ActiviteView';
// eslint-disable-next-line import/no-cycle
import { GestionDirigeantView } from './GestionDirigeantView/GestionDirigeantView';
// eslint-disable-next-line import/no-cycle
import { GestionNDDView } from './GestionNDDView/GestionNDDView';

export type customItemJsonProps = {
    formContext: ExtandedFormContext;
    props: CustomItemRenderFieldProps;
    legalForm?: string;
};

export const customItemRenderer: CustomItemFormStructure['renderField'] = (
    formContext: ExtandedFormContext,
    props: CustomItemRenderFieldProps,
) => {
    let display = true;
    let disabled = false;

    if (props.display === false) {
        display = false;
    } else if (typeof props.display === 'function') {
        display = props.display(formContext);
    }

    if (display === false) {
        return null;
    }

    if (props.disabled === true) {
        disabled = true;
    } else if (props.disabled) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        disabled = props.disabled(formContext);
    }

    switch (props.name) {
        case 'dirigeants_pp_sarl':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SARL"
                />
            );
            break;
        case 'dirigeants_pm_sarl':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SARL"
                />
            );
            break;
        case 'dirigeants_pp_sas':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SAS"
                />
            );
            break;
        case 'dirigeants_pm_sas':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SAS"
                />
            );
            break;
        case 'dirigeants_pp_sci':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                />
            );
            break;
        case 'dirigeants_pm_sci':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                />
            );
            break;
        case 'dirigeants_pp_scs':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                />
            );
            break;
        case 'dirigeants_pm_scs':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                />
            );
            break;
        case 'dirigeants_pp_snc':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                />
            );
            break;
        case 'dirigeants_pm_snc':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                />
            );
            break;
        case 'dirigeants_pp_sa':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SA"
                />
            );
            break;
        case 'dirigeants_pm_sa':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SA"
                />
            );
            break;
        case 'dirigeants_pp_gie':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="GIE"
                />
            );
            break;
        case 'dirigeants_pm_gie':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="GIE"
                />
            );
            break;
        case 'dirigeants_pp_sca':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SCA"
                />
            );
            break;
        case 'dirigeants_pm_sca':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SCA"
                />
            );
            break;
        case 'dirigeants_pp_scp':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SCP"
                />
            );
            break;
        case 'dirigeants_pm_scp':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SCP"
                />
            );
            break;
        case 'dirigeants_pp_agricole':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="AGRICOLE"
                />
            );
            break;
        case 'dirigeants_pm_agricole':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="AGRICOLE"
                />
            );
            break;
        case 'dirigeants_pp_societe_etrangere':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SOCIETE_ETRANGERE"
                />
            );
            break;
        case 'dirigeants_pm_societe_etrangere':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SOCIETE_ETRANGERE"
                />
            );
            break;
        case 'dirigeants_pp_liquidateur':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="LIQUIDATEUR"
                />
            );
            break;
        case 'dirigeants_pm_liquidateur':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="LIQUIDATEUR"
                />
            );
            break;
        case 'beneficiaires_effectif':
            return (
                <BeneficiaireView
                    formContext={formContext}
                    props={props}
                />
            );
            break;
        case 'entreprises_intervenant':
            return (
                <EntreprisesIntervenantView
                    formContext={formContext}
                    props={props}
                />
            );
            break;
        case 'noms_de_domaine':
            return (
                <NomsDeDomaineView
                    formContext={formContext}
                    props={props}
                />
            );
            break;
        case 'activite':
            return (
                <ActiviteView
                    formContext={formContext}
                    props={props}
                />
            );
            break;
        case 'gestion_dirigeant':
            return (
                <GestionDirigeantView
                    formContext={formContext}
                    props={props}
                />
            );
            break;
        case 'gestion_ndd':
            return (
                <GestionNDDView
                    formContext={formContext}
                    props={props}
                />
            );
            break;
        case 'total_detention_directe_capital':
        case 'total_detention_indirecte_capital':
        case 'total_detention_directe_vote':
        case 'total_detention_indirecte_vote': {
            const values = [];
            if (props.rules?.renderTotalDetention) {
                for (let i = 0; i < props.rules?.renderTotalDetention?.length; i++) {
                    const valueWatched = formContext.watch(
                        props.rules.renderTotalDetention[i] as string,
                    );
                    values.push(parseFloat(valueWatched === '' ? 0 : valueWatched));
                }
            }
            return (
                <Box sx={{ margin: '25px 0' }}>
                    <PercentWidget
                        label={props.inputlabel as string}
                        values={values}
                    />
                </Box>
            );
            break;
        }
        default:
            return (
                <Typography variant="l2dh7">
                    Impossible d&apos;afficher le customItem le type type {props.name} n&apos;est
                    pas pris en charge
                </Typography>
            );
    }
};
